import React, { useState } from 'react';
import { TextField, Autocomplete, FormControl } from '@mui/material';

const SearchableSelect = ({ partnerList, edit, value, onChange, error }) => {
    return (
        <FormControl  sx={{ ml: 2, minWidth: 120, maxWidth:800 }}>
            <Autocomplete
                freeSolo
                options={partnerList}
                getOptionLabel={(option) => (option ? `${option.name} (${option.email})` : "")}
                disabled={!edit}
                value={partnerList.find(p => p._id=== value) || null}
                onChange={(event, newValue) => onChange({ target: { value: newValue ? newValue._id : "" } })}
                isOptionEqualToValue={(option, value) => option._id === value._id}
                renderInput={(params) => (
                    <TextField error={error} {...params} label="Партнер" placeholder="Поиск..." />
                )}
            />
        </FormControl>
    );
};

export default SearchableSelect;

